<template>
	<div class="w1200">
		<div class="association-brief-box">
			<div class="crumbs">
				<span><a href="#/">首页 ></a></span>
				<span>联系我们</span>
			</div>
			<div class="article-box w1000">
				<h2>北京建筑设施服务企业协会</h2>

				<div class="msg">联系电话：010-8352 0973</div>
				<div class="msg">协会地址：北京市丰台区西局东街首科大厦A座1215室</div>
				<div class="img">
					<img src="../assets/images/map.jpg">
				</div>

			</div>
		</div>
<!--		<div class="baidumap" id="allmap">
		</div>-->
	</div>
</template>
<!--<script src='http://api.map.baidu.com/api?v=2.0&ak=vbo3f9OotSIyH6ReUUT77HsdjUN6HY84&callback=init'></script>-->
<script>
	import Vue from 'vue';
	export default {

		data() {
			return {

			}
		},
		mounted() {
			/*this.baiduMap()*/
		},
		methods: {
	/*		baiduMap() {      

				    // 百度地图API功能
				var map = new BMap.Map("allmap");
				var point = new BMap.Point(116.320775, 39.883709);
				var marker = new BMap.Marker(point); // 创建标注
				map.addOverlay(marker); // 将标注添加到地图中
				map.centerAndZoom(point, 15);
				var opts = {
					width: 200, // 信息窗口宽度
					height: 100, // 信息窗口高度
					title: "北京建筑设施服务企业协会", // 信息窗口标题
					enableMessage: true, //设置允许信息窗发送短息
					message: ""
				}
				var infoWindow = new BMap.InfoWindow("地址：北京丰台区西局东街首科大厦A座1215", opts); // 创建信息窗口对象 

				marker.addEventListener("click", function() {
					map.openInfoWindow(infoWindow, point); //开启信息窗口
				});
			}*/

		},
		components: {}
	}
</script>

<style>
	@import "../assets/css/detail.css";
	.baidumap {
		width: 980px;
		height: 400px;
		border: 1px solid #ccc;
	}
</style>


// WEBPACK FOOTER //
// src/components/ContactUs.vue